module.exports = __webpack_public_path__ + "static/faq2-dea614ec47e1093148c027a50461f4df.jpg";